export default __webpack_public_path__ + "static/media/gameplayBgMb.146dff49.png";